import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type DeleteClassificationRequest = {
  classificationId: string;
  recursive?: boolean;
  hardDelete?: boolean;
};

export const deleteClassificationApi = async ({
  classificationId,
  recursive = true,
  hardDelete = true,
}: DeleteClassificationRequest): Promise<void> => {
  try {
    await openMetadataApiClient.delete(`/classifications/${encodeURIComponent(classificationId)}`, {
      params: {
        recursive,
        hardDelete,
      },
    });
  } catch (error) {
    console.error('Failed to delete classification:', error);
    throw error;
  }
};

export type { DeleteClassificationRequest };
